import { StringKey } from './string-key.const';

export enum Locale {
  EN = 'en',
  FR = 'fr',
}

export const localeTitleMap: Record<Locale, StringKey> = {
  [Locale.EN]: 'ENGLISH',
  [Locale.FR]: 'FRENCH',
};
